import { useReducer } from 'react';
import { filterCriteriaReducer } from './reducer';
import { filterInitialState } from './initialState';

const useFilterCriteria = (initialState = filterInitialState) =>
  useReducer(filterCriteriaReducer, initialState);

export default useFilterCriteria;
